import request from '../utils/request';
import { DictionaryDto } from './dictionary';

export function fetchRegionsDict(): Promise<DictionaryDto[]> {
    return request('/regions/user').then(({ data }) => data as DictionaryDto[]);
}

export interface RegionDto extends DictionaryDto {
    index?: string;
    latitude?: number;
    longitude?: number;
    is_show_freelancer?: boolean;
    taptophone_code?: string;
}

export function initRegion(): RegionDto {
    return {
        id: '',
        code: '',
        description: '',
        status: '',
        index: '',
        taptophone_code: '',
    };
}
